import React from 'react';
import { Helmet } from 'react-helmet';
import mantisWhiteLogo from '../Assets/img/mantisWhiteLogo2.png';
import PublicFooter from './PublicFooter';
import './styles/termsConditions.scss';
import './styles/publicPages.scss';

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Términos y Condiciones - Mantis</title>
        <meta name="description" content="Términos y condiciones de uso de la plataforma Mantis" />
      </Helmet>
      
      <div className="terms-conditions-page">
        {/* Header */}
        <header className="page-header">
          <div className="container">
            <div className="logo-container">
              <img src={mantisWhiteLogo} alt="Mantis Logo" className="logo" />
            </div>
            <h1 className="doc-title">TÉRMINOS Y CONDICIONES DEL SERVICIO MANTIS APP S.A.S.</h1>
          </div>
        </header>

        {/* Main Content */}
        <main className="page-content">
          <div className="container">
            <div className="content-wrapper">
              <p className="subtitle">
                Última actualización: 27 de Julio de 2025
              </p>
              
              <section className="terms-section">
                <h2 className="subtitle">1. ACEPTACIÓN</h2>
                <p>
                  Este acuerdo establece los términos y condiciones ("Términos") bajo los cuales 
                  Mantis App S.A.S. ("Mantis", "nosotros") proporciona acceso y uso de su plataforma 
                  tecnológica con agente de inteligencia artificial ("Plataforma") a usted ("Cliente").
                </p>
                <p>
                  Al aceptar utilizar la Plataforma, el Cliente acepta estar vinculado por estos 
                  Términos, los cuales se regirán e interpretarán de acuerdo con las leyes de Colombia.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">2. NATURALEZA DE LOS SERVICIOS</h2>
                <p>
                  Mantis pone a disposición del Cliente un agente de inteligencia artificial 
                  ("Agente IA") que, en función de la información, parámetros, políticas y 
                  presupuestos definidos por el Cliente:
                </p>
                <ul>
                  <li>Valida, aprueba o rechaza solicitudes de compra.</li>
                  <li>Ejecuta y controla presupuestos.</li>
                  <li>Asiste en la creación del presupuesto corporativo.</li>
                </ul>
                <p>
                  La Plataforma es una herramienta tecnológica de apoyo y no sustituye el 
                  juicio humano ni constituye asesoría financiera, contable o legal. El Cliente 
                  es responsable de todas las decisiones y acciones derivadas del uso de la 
                  Plataforma y asume los riesgos asociados.
                </p>
                <p>
                  Mantis no realiza servicios financieros ni directos ni indirectos, ni actúa 
                  como representante legal o contractual del Cliente frente a terceros. Los 
                  actos y transacciones resultantes del uso de la Plataforma son responsabilidad 
                  exclusiva del Cliente y, cuando involucren a terceros, estarán sujetos a los 
                  términos y condiciones de dichos terceros.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">3. OBLIGACIONES DEL CLIENTE</h2>
                <p>
                  El Cliente se compromete a:
                </p>
                <ul>
                  <li>Suministrar de manera completa, detallada y oportuna toda la información necesaria para la correcta operación de la Plataforma.</li>
                  <li>Configurar y mantener actualizados los parámetros de validación, aprobación y control presupuestal.</li>
                  <li>Restringir y controlar el acceso a la Plataforma por parte de usuarios autorizados, preservando la confidencialidad de las credenciales.</li>
                  <li>Verificar y supervisar las decisiones automatizadas cuando sea necesario.</li>
                  <li>Cumplir con las normas legales, fiscales, contables, de contratación y compras aplicables a sus operaciones.</li>
                  <li>Mantener respaldos actualizados de la información procesada en la Plataforma.</li>
                </ul>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">4. LIMITACIÓN DE RESPONSABILIDAD</h2>
                <p>
                  Mantis no será responsable por:
                </p>
                <ul>
                  <li>Errores, compras indebidas, asignaciones presupuestales erróneas o incumplimientos normativos derivados de datos incompletos, inexactos o desactualizados proporcionados por el Cliente, o de configuraciones internas definidas por este.</li>
                  <li>Daños, pérdidas o consecuencias derivadas de aprobaciones o rechazos automáticos realizados por el Agente IA.</li>
                  <li>Fallas, demoras o errores en servicios de terceros, incluyendo ERP, pasarelas de pago, entidades financieras, proveedores o aliados.</li>
                  <li>Pérdidas indirectas, lucro cesante, daños consecuenciales o reputacionales.</li>
                  <li>Interrupciones o cambios en los Servicios por motivos de fuerza mayor o caso fortuito, tales como desastres naturales, fallas tecnológicas, ciberataques, actos gubernamentales o situaciones imprevistas.</li>
                </ul>
                <p>
                  La responsabilidad máxima de Mantis se limitará al valor efectivamente pagado 
                  por el Cliente en los tres (3) meses anteriores al evento que originó la reclamación.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">5. DISPONIBILIDAD Y ALCANCE DEL SERVICIO</h2>
                <p>
                  La Plataforma se presta "tal cual" y "según disponibilidad".
                </p>
                <p>
                  Mantis podrá realizar actualizaciones, mantenimientos o mejoras sin previo 
                  aviso, procurando minimizar las interrupciones. El Cliente reconoce que la 
                  disponibilidad ininterrumpida no está garantizada.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">6. ACUERDO DE NIVEL DE SERVICIO (SLA)</h2>
                <p>
                  Mantis prestará atención básica de soporte en horario de oficina, de lunes 
                  a viernes de 8:00 a.m. a 6:00 p.m. (hora Colombia), excluyendo festivos nacionales.
                </p>
                <p>
                  El soporte básico incluye:
                </p>
                <ul>
                  <li>Recepción y registro de incidentes reportados por el Cliente.</li>
                  <li>Orientación inicial para resolver problemas de uso de la Plataforma.</li>
                  <li>Escalamiento de incidencias técnicas al equipo correspondiente.</li>
                </ul>
                <p>
                  El tiempo de respuesta inicial a un reporte será de máximo un (1) día hábil. 
                  El tiempo de resolución dependerá de la complejidad del incidente y de factores 
                  fuera del control de Mantis.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">7. PROPIEDAD INTELECTUAL</h2>
                <p>
                  Todos los derechos de propiedad intelectual sobre la Plataforma, el Agente IA, 
                  su código, modelos, algoritmos, interfaces y documentación pertenecen exclusivamente 
                  a Mantis.
                </p>
                <p>
                  El Cliente recibe una licencia no exclusiva, intransferible y revocable para 
                  el uso de la Plataforma conforme a estos Términos.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">8. INTEGRACIONES CON TERCEROS</h2>
                <p>
                  En caso de integrarse la Plataforma con sistemas externos (ERP, pasarelas de 
                  pago, bases de datos, plataformas de terceros), Mantis:
                </p>
                <ul>
                  <li>No garantiza el funcionamiento ininterrumpido de dichas integraciones.</li>
                  <li>No asume responsabilidad por fallas, interrupciones o errores imputables a terceros.</li>
                </ul>
                <p>
                  El Cliente será responsable de los contratos y configuraciones necesarias con dichos terceros.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">9. SEGURIDAD Y CONFIDENCIALIDAD</h2>
                <p>
                  Mantis adoptará medidas razonables para proteger la información proporcionada 
                  por el Cliente, pero no garantiza seguridad absoluta ante accesos no autorizados 
                  o ciberataques.
                </p>
                <p>
                  El Cliente acepta este riesgo y mantendrá respaldos actualizados de su información. 
                  La información del Cliente será tratada como confidencial y solo se compartirá 
                  con terceros en los casos necesarios para la prestación del servicio o por 
                  requerimiento legal.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">10. CAMBIOS EN LOS TÉRMINOS Y CONDICIONES</h2>
                <p>
                  Mantis podrá modificar estos Términos en cualquier momento. Si se modifican, 
                  Mantis informará al Cliente a través de la Plataforma o por medios electrónicos, 
                  y de no existir cancelación del servicio dentro de los tres (3) días siguientes 
                  a su publicación, se entenderán aceptados por el Cliente.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">11. LEY APLICABLE Y JURISDICCIÓN</h2>
                <p>
                  Estos Términos se regirán por las leyes de la República de Colombia.
                </p>
                <p>
                  Cualquier disputa, controversia o reclamación derivada de estos Términos será 
                  resuelta por la jurisdicción competente de los jueces de la ciudad de Bogotá, Colombia.
                </p>
              </section>

              <section className="terms-section">
                <h2 className="subtitle">EXONERACIÓN ESPECÍFICA</h2>
                <p>
                  El Cliente reconoce y acepta expresamente que:
                </p>
                <ul>
                  <li>El uso de la Plataforma y del Agente IA se realiza bajo su exclusiva responsabilidad.</li>
                  <li>Las decisiones generadas por la Plataforma son asistencias tecnológicas y no constituyen instrucciones vinculantes.</li>
                  <li>Cualquier compra indebida, ejecución presupuestal incorrecta o pérdida económica resultante de un uso inadecuado, configuración errónea o falta de supervisión será de responsabilidad exclusiva del Cliente.</li>
                </ul>
              </section>
            </div>
          </div>
        </main>

        {/* Footer */}
        <PublicFooter />
      </div>
    </>
  );
};

export default TermsAndConditions;
